import { AnchorHTMLAttributes } from 'react'
import { unsafeResource } from './UnsafeResource'

export const UnsafeResourceLink = unsafeResource<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(
  'a',
  'UnsafeResourceLink',
  { rel: 'noreferrer', target: '_blank' },
)
